import script from "./EmptyState.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyState.vue?vue&type=script&setup=true&lang=js"

import "./EmptyState.vue?vue&type=style&index=0&id=2c514d2a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c514d2a"]])

export default __exports__